import _toConsumableArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { mappingResultError, Result, UseCase } from '@digibricks/domains';
import { NoneValue } from '../../../../core';
export var DELETE_QUESTION_USE_CASE = 'DELETE_QUESTION_USE_CASE';
export var DeleteQuestionUseCase = /*#__PURE__*/function (_UseCase) {
  _inherits(DeleteQuestionUseCase, _UseCase);

  var _super = _createSuper(DeleteQuestionUseCase);

  function DeleteQuestionUseCase(questionRepository) {
    var _this;

    _classCallCheck(this, DeleteQuestionUseCase);

    _this = _super.call(this);
    _this.questionRepository = questionRepository;
    return _this;
  }

  _createClass(DeleteQuestionUseCase, [{
    key: "buildUseCase",
    value: function () {
      var _buildUseCase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input) {
        var _newQuestions$find;

        var currentQuestion, questions, headings, _input$isSkipApiCall, isSkipApiCall, newQuestions, previousQuestion, nextQuestion, filteredQuestions, newHeadings, previousHeading, nextHeading, resultOrError, _resultOrError;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                currentQuestion = input.currentQuestion, questions = input.questions, headings = input.headings, _input$isSkipApiCall = input.isSkipApiCall, isSkipApiCall = _input$isSkipApiCall === void 0 ? false : _input$isSkipApiCall;
                currentQuestion.deActivate();
                newQuestions = questions.filter(function (q) {
                  return q.id.toString() !== currentQuestion.id.toString();
                });
                previousQuestion = (_newQuestions$find = newQuestions.find(function (question) {
                  return question.id.toString() === currentQuestion.previousQuestionId;
                })) !== null && _newQuestions$find !== void 0 ? _newQuestions$find : null;
                nextQuestion = newQuestions.find(function (question) {
                  return question.previousQuestionId === currentQuestion.id.toString();
                });

                if (nextQuestion) {
                  nextQuestion.updatePreviousQuestionId(previousQuestion ? previousQuestion.id.toString() : NoneValue);
                  filteredQuestions = newQuestions.filter(function (q) {
                    return q.id.toString() !== nextQuestion.id.toString();
                  });
                  newQuestions = [].concat(_toConsumableArray(filteredQuestions), [nextQuestion]);
                }

                if (!headings) {
                  _context.next = 18;
                  break;
                }

                newHeadings = _toConsumableArray(headings);
                previousHeading = newHeadings.find(function (h) {
                  return h.nextQuestionId === currentQuestion.id.toString();
                });
                nextHeading = newHeadings.find(function (h) {
                  return h.previousQuestionId === currentQuestion.id.toString();
                });

                if (previousHeading && nextHeading) {
                  previousHeading.updateNextQuestionId(NoneValue);
                  nextHeading.updatePreviousQuestionId(NoneValue);
                } else {
                  if (previousHeading) {
                    if (nextQuestion) {
                      previousHeading.updateNextQuestionId(nextQuestion.id.toString());
                    }
                  }

                  if (nextHeading) {
                    if (previousQuestion) {
                      nextHeading.updatePreviousQuestionId(previousQuestion.id.toString());
                    }
                  }
                }

                if (isSkipApiCall) {
                  _context.next = 17;
                  break;
                }

                _context.next = 14;
                return this.questionRepository["delete"](currentQuestion.id.toString());

              case 14:
                resultOrError = _context.sent;

                if (!resultOrError.isFailure) {
                  _context.next = 17;
                  break;
                }

                return _context.abrupt("return", mappingResultError(resultOrError));

              case 17:
                return _context.abrupt("return", Result.ok({
                  deletedQuestion: currentQuestion,
                  nextQuestion: nextQuestion,
                  newHeadings: newHeadings,
                  newQuestions: newQuestions
                }));

              case 18:
                if (isSkipApiCall) {
                  _context.next = 24;
                  break;
                }

                _context.next = 21;
                return this.questionRepository["delete"](currentQuestion.id.toString());

              case 21:
                _resultOrError = _context.sent;

                if (!_resultOrError.isFailure) {
                  _context.next = 24;
                  break;
                }

                return _context.abrupt("return", mappingResultError(_resultOrError));

              case 24:
                return _context.abrupt("return", Result.ok({
                  deletedQuestion: currentQuestion,
                  nextQuestion: nextQuestion,
                  newQuestions: newQuestions
                }));

              case 25:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function buildUseCase(_x) {
        return _buildUseCase.apply(this, arguments);
      }

      return buildUseCase;
    }()
  }]);

  return DeleteQuestionUseCase;
}(UseCase);